import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a7a58f86")

_pushScopeId("data-v-a7a58f86")
const _hoisted_1 = { class: "SMapSearch" }
const _hoisted_2 = { class: "SMapSearch__wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "wrapper__city"
}
const _hoisted_4 = {
  key: 0,
  class: "SMapSearch__results"
}
const _hoisted_5 = {
  key: 0,
  class: "results__loading"
}
const _hoisted_6 = { class: "result__title" }
const _hoisted_7 = { class: "result__description" }
const _hoisted_8 = {
  key: 1,
  class: "results__empty"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.city)
        ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.city.name), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchState.query = $event)),
        placeholder: "Адрес или объект",
        class: "SMapSearch__input",
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
      }, null, 544), [
        [_vModelText, _ctx.searchState.query]
      ])
    ]),
    (_ctx.searchState.last_query)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          (_ctx.searchState.state.is_loading)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode(_component_s_loader)
              ]))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                (_ctx.searchState.results.length)
                  ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.searchState.results, (result, i) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "results__result",
                        key: `search-result-${i}`,
                        onClick: ($event: any) => (_ctx.selectResult(result))
                      }, [
                        _createVNode("p", _hoisted_6, _toDisplayString(result.name), 1),
                        _createVNode("p", _hoisted_7, _toDisplayString(result.description), 1)
                      ], 8, ["onClick"]))
                    }), 128))
                  : (_openBlock(), _createBlock("div", _hoisted_8, " По запросу \"" + _toDisplayString(_ctx.searchState.last_query) + "\" ничего не найдено ", 1))
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
})